/* eslint-disable */
import React from "react";
import g from "glamorous";
import { css } from "glamor";
import Layout from "../components/layout";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import SearchWidget from "../components/SearchWidget";
import { Helmet } from "react-helmet";
import { Container } from "glamorous-grid";
import { Link } from "gatsby";
import { FaHome } from "react-icons/fa";

const Wrapper = g.main({
  maxWidth: `1000px`,
  margin: `0 auto`,
  paddingBottom: `4em`,
});

const Breadcrumb = g.ul({
  fontSize: `13px`,
  lineHeight: `20px`,
  marginLeft: `0 !important`,
  marginTop: `50px !important`,
  marginBottom: `20px !important`,
  fontWeight: `500`,
  letterSpacing: `.015em`,
});

const BreadcrumbItem = g.li({
  display: `inline`,
  "&:first-of-type": {
    "&::before": {
      content: `none`,
    },
  },
  "&::before": {
    content: `/`,
    padding: `0 .5em`,
  },
});

const cssBreadcrumbLink = css({
  color: `#3c4d68`,
  borderBottom: `none`,
});

export default () => (
  <Layout>
    <g.Div id="page-wrap" margin={`0 auto`} backgroundColor={`#fcfcfc`}>
      <Helmet>
        <title>Effectuer une recherche sur le site | Dr Cédric Kron</title>
        <meta
          name="description"
          content="Effectuez une recherche sur le site du Dr Cédric Kron, médecin esthétique et chirurgien plastique exerçant à Paris 17e arrondissement."
        />
        <html lang="fr" />
        <link
          rel="alternate"
          hreflang="en"
          href="https://www.dr-kron.com/en/search/"
        />
        <script type="application/ld+json">{` {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Effectuer une recherche sur le site",
        "item": "https://www.dr-kron.com/recherche/"
        }]
            }
  `}</script>
      </Helmet>
      <Menu current="recherche" pathEn="/en/search/" />

      <Wrapper>
        <Container css={{ padding: `0 15px !important`, minHeight: `40vw` }}>
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to="/" {...cssBreadcrumbLink} title="Page d'accueil">
                <FaHome
                  css={{
                    fontSize: `1.2em`,
                    paddingBottom: `.2em`,
                    transform: `translateY(5px)`,
                  }}
                />
              </Link>
            </BreadcrumbItem>

            <BreadcrumbItem>Effectuer une recherche sur le site</BreadcrumbItem>
          </Breadcrumb>
          <div className="container" css={{ padding: `1px` }}>
            <SearchWidget instance="site-search-fr" placeholder="Rechercher..." />
          </div>
        </Container>
      </Wrapper>
      <Footer />
    </g.Div>
  </Layout>
);
